import ApiService from "../api.service";
const DashboardService = {
    GetAuctionInfoByStatusAuction(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatusAuction?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByStatusShop(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatusShop?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
  GetAuctionInfoByStatusEtender(
    StartDate,
    EndDate,
    OblastId,
    RegionId,
    LotId,
    ItemGroupName
  ) {
    return ApiService.get(
      `/Report/GetAuctionInfoByStatusEtender?StartDate=${StartDate}&EndDate=${EndDate}&OblastId=${OblastId}&RegionId=${RegionId}&LotId=${LotId}&ItemGroupName=${ItemGroupName}`
    );
  },
 
 
 
};
export default DashboardService;
